







import { Component, Prop, Vue } from 'vue-property-decorator'
import { TypeformResponseAnswer } from '@/api/model/typeform/typeform-response-answer'

@Component
export default class FieldTypeBoolean extends Vue {
    @Prop({ required: true }) readonly value!: TypeformResponseAnswer
}
